import * as React from "react";
import { getBrandLogo, x_by_brand } from "@/helpers/branding-helpers";
import { useBrandingContext } from "@/contexts/BrandingContext";

export type LogoProps = {
  url?: string;
  onClick?: () => void;
};

export const Logo: React.FC<LogoProps> = ({ url, onClick }) => {
  const { brand } = useBrandingContext();
  const logoSrc = getBrandLogo(brand);

  const x = x_by_brand(brand);

  if (onClick) {
    return <img onClick={onClick} src={logoSrc} alt="Logo" width={x} height={26} />;
  }

  if (url) {
    return (
      <a href={url}>
        <img src={logoSrc} alt="Logo" width={x} height={26} />
      </a>
    );
  }

  return <img src={logoSrc} alt="Logo" width={x} height={26} />;
};
